import './styles.css';
import AuthForm from './components/AuthForm';

const App = () => {
  return (
    <div className="App">
      <AuthForm/>
    </div>
  );
};

export default App;
